import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, QueryParameter, ModalService, NotificationService } from 'yt-ng-framework';
import { FinDokument } from './fin-dokument';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { List } from 'immutable';
import { FinDokumentView } from './fin-dokument-view';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-fin-dokument-update',
  templateUrl: './fin-dokument-update.component.html'
})
export class FinDokumentUpdateComponent extends BaseUpdateComponent<FinDokument> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService, modalService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc('Broj', Validators.required, 'required', 'FINDOKUMENT.BRNAL.VALIDATION.REQUIRED');
    this.addValidatorToFc('Broj', Validators.maxLength(20), 'maxlength', 'FINDOKUMENT.BRNAL.VALIDATION.MAXLENGTH');
    this.addValidatorToFc('PodVrstaDokumentaStavkaID', Validators.required, 'required', 'FINDOKUMENT.PODVRSTADOKUMENTASTAVKA.VALIDATION.REQUIRED');
    this.addValidatorToFc('Datum', Validators.required, 'required', 'FINDOKUMENT.DATNAL.VALIDATION.REQUIRED');

    this.IDProcessed
            .subscribe((value) => {
                if (value && this.Item.ID == -1) {
                    this.baseFormGroup.get('PodVrstaDokumentaStavkaID').enable();
                    this.baseFormGroup.get('PodVrstaDokumentaStavkaID').updateValueAndValidity();
                    this.baseFormGroup.get('Broj').enable();
                    this.baseFormGroup.get('Broj').updateValueAndValidity();
                    this.baseFormGroup.get('Datum').enable();
                    this.baseFormGroup.get('Datum').updateValueAndValidity();
                    let dateNow = new Date();
                    let date: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate());
                    this.baseFormGroup.patchValue({ DatNal: date });
                    this.baseFormGroup.get('Datum').updateValueAndValidity();
                }
                else{
                    this.baseFormGroup.get('PodVrstaDokumentaStavkaID').disable();
                    this.baseFormGroup.get('PodVrstaDokumentaStavkaID').updateValueAndValidity();
                    this.baseFormGroup.get('Broj').disable();
                    this.baseFormGroup.get('Broj').updateValueAndValidity();
                    this.baseFormGroup.get('Datum').disable();
                    this.baseFormGroup.get('Datum').updateValueAndValidity();
                }
            })
            this.ItemSaved
            .subscribe((data: FinDokumentView) => {
                if (data)
                    this.Item.BrojDokumenta = data.BrojDokumenta;

            })
  }

  onPodVrstaSelect() {
    this.getBrojDokumenta();
}

getBrojDokumenta() {
    let podvrstaid = this.baseFormGroup.get('PodVrstaDokumentaStavkaID').value;
    let datum = this.baseFormGroup.get('Datum').value;
    if (this.Item.ID == -1 && podvrstaid && datum)
        this.baseDataService.GetData('FinDokument', 'KreirajBrojDokumenta', { 'PodVrstaDokumentaStavkaID': podvrstaid, 'Datum': datum })
            .subscribe(data => {
                this.baseFormGroup.patchValue({ Broj: data });
                this.baseFormGroup.get('Broj').updateValueAndValidity();
            })

}

  editMode:boolean=false;
  AddDocument() { }
  //Print(ID1) { }
  item:any;
  PrintKnj(item1){}
  SaveMaster(qq){}

  onDatumChange(value) {
    if (value != null) {
        //let datum: QueryParameter = new QueryParameter();
        //datum.Name = 'Datum';
        //datum.Value = value;
        let parameterList: List<QueryParameter> = List([new QueryParameter('Datum', value)]);
        //parameterList = parameterList.push(datum);
        this.TransferParameters = this.TransferParameters.set(0, parameterList);
        this.getBrojDokumenta();
    }
}
}
